export default "__VITE_ASSET__BByJANYw__"